<template>
  <b-img
    v-bind="{height: 50}"
    :src="require('@/assets/images/logo/hostmatic.png')"
    alt="Hostmatic"
  />
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  components: { BImg }
}
</script>
